import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=42520bd9&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"
import style0 from "./Payment.vue?vue&type=style&index=0&id=42520bd9&prod&lang=scss&scoped=true"
import style1 from "./Payment.vue?vue&type=style&index=1&id=42520bd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42520bd9",
  null
  
)

export default component.exports